import styled from '@emotion/styled';
import Content from './Content';
import { FilterProvider } from './Filter';

const Container = styled.div`
  margin-bottom: 16px;
  .ant-tabs-nav {
    margin: 16px 0 0;
  }
`;

interface Props {}

const AssistantPerf = (props: Props) => {
  return (
    <Container>
      <FilterProvider initialValue={{ conversationType: 2 }}>
        <Content selType="statics" />
      </FilterProvider>
    </Container>
  );
};

export default AssistantPerf;
